import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default () => ({
  quoteText: '',
  swiper: null,
  activeSlide: 0,

  updateQuoteText(quote) {
    this.quoteText = quote;
  },

  setActiveSlide(slideIndex, quoteText) {
    this.activeSlide = slideIndex;
    this.updateQuoteText(quoteText);
  },

  init() {
    this.swiper = new Swiper(this.$refs['swiperContainer'], {
      initialSlide: 3,
      modules: [Autoplay, Pagination],
      autoHeight: true,
      autoplay: { delay: 3000 },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        enabled: true,
      },
      slidesPerView: 1,
      breakpoints: {
        640: {
          pagination: { enabled: false },
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });

    this.swiper.on('slideChange', (swiper) => {
      const currentSlide = swiper.slides[swiper.activeIndex];
      const quoteText = currentSlide.querySelector('[x-ref="quote"]').innerText;
      this.updateQuoteText(quoteText);
    });
  },
});
